import { CreateSlotDTO } from '../Modules/Slot/Model/Slot';

/** 서버 batch_create API 1회 요청당 최대 슬롯 수 */
export const BATCH_CREATE_CHUNK_SIZE = 25;

/** 분할 업로드 시 청크 간 대기(ms) */
export const BATCH_CREATE_CHUNK_DELAY_MS = 10000;

export interface BatchCreateChunk {
  request: { count: number; slots: CreateSlotDTO[] };
  tempIds: number[];
}

/**
 * batch_create 요청을 서버 제한(25개)에 맞게 분할합니다.
 * - 동일 템플릿(count > 1, slots 1개): count 기준 분할
 * - 엑셀/개별 행(slots 여러 개): slots 배열 기준 분할
 */
export function splitBatchCreateIntoChunks(
  request: { count: number; slots: CreateSlotDTO[] },
  tempIds: number[],
): BatchCreateChunk[] {
  const chunks: BatchCreateChunk[] = [];
  const totalCount = tempIds.length;

  if (request.slots.length === 1) {
    const baseSlot = request.slots[0];
    for (let i = 0; i < totalCount; i += BATCH_CREATE_CHUNK_SIZE) {
      const chunkTempIds = tempIds.slice(i, i + BATCH_CREATE_CHUNK_SIZE);
      chunks.push({
        request: { count: chunkTempIds.length, slots: [baseSlot] },
        tempIds: chunkTempIds,
      });
    }
    return chunks;
  }

  for (let i = 0; i < request.slots.length; i += BATCH_CREATE_CHUNK_SIZE) {
    const chunkSlots = request.slots.slice(i, i + BATCH_CREATE_CHUNK_SIZE);
    chunks.push({
      request: { count: 1, slots: chunkSlots },
      tempIds: tempIds.slice(i, i + chunkSlots.length),
    });
  }

  return chunks;
}
